import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@environments/environment';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';

@Component({
  selector: 'app-quotations-list',
  templateUrl: './quotations-list.component.html',
  styleUrls: ['./quotations-list.component.less']
})
export class QuotationsListComponent {
  currentProject: any;
  quotations: any[];
  customQuotations: any = [];
  filteredQuotations: any[];
  financials: any;
  inited: boolean = false;
  isLoaded:boolean = false;

  constructor(
    private router: Router,
    private globalDataService: GlobalDataService,
    private requestV2Service: RequestV2Service
  ) {
    this.quotations = [];
    this.filteredQuotations = [];

    this.globalDataService.getCurrentProject().subscribe(async (project: any) => {
      if (!project) return;

      if (!this.inited) {
        this.inited = true;
        this.currentProject = project;
        const quotationResults = await this.requestV2Service.getQuotations(project.id);
        this.quotations = quotationResults.items;
        // Search for quotation financials
        const versionsResults = await this.requestV2Service.getVersions(
          this.quotations.map(i => i.id).join(','), {}
        );

        for (let i = 0; i < this.quotations.length; i = i + 1) {
          const quotation = this.quotations[i];
          const versions = versionsResults.items.filter(i => i.id_quotation === quotation.id);
          for (const version of versions) {
            const financial = await this.requestV2Service.getQuotationVersionFinancial(version.id);
            if (version._related && version._related._quotation_variant) {
              version.title = `${version.title} - ${version._related._quotation_variant.name}`;
            }
            this.customQuotations.push({
              financial,
              version,
              ...quotation
            });
          }
        }

        this.resetQuotations();
      }
    });
  }

  private resetQuotations() {
    this.filteredQuotations = [];

    this.customQuotations.forEach((quotation) => {
      const quotationCopy: any = { ...quotation };
      this.filteredQuotations.push(quotationCopy);
    });
    this.isLoaded = true;
  }

  private filter(text: string) {
    if (!text || text.length <= 0) {
      this.resetQuotations();

      return;
    }

    this.filteredQuotations = [];

    this.quotations.forEach((quotation) => {
      if (quotation.title.toLowerCase().includes(text.toLowerCase())) {
        this.filteredQuotations.push(quotation);
      }
    });
  }

  searchEvent(event) {
    this.filter(event.target.value);
  }

  isEmpty(): boolean {
    return !this.filteredQuotations || this.filteredQuotations.length <= 0;
  }

  openQuotation(quotation: any) {
    // tslint:disable-next-line:max-line-length
    return `${environment.customer_url}/quotations/${quotation.id}/versions/${quotation.version.id}`;
  }

  calculateTTC(quotation: any): number {
    const vat = Object.keys(quotation.financial.customer.vat)
      .reduce(
        (acc, item) => {
          return acc + quotation.financial.customer.vat[item];
        },
        0
      );

    return quotation.financial.customer.total + vat;
  }
}
